<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="title">รายละเอียด</h5>
    </template>
    <template v-slot:section-body>
      <form>
        <div class="row">
          <div class="col-md-8">
            <FormGroup>
              <h5 class="name">ชื่อหน้า</h5>
              <input
                type="text"
                placeholder="ชื่อหน้า"
                :class="{ 'is-invalid': saveLandingPageStateError.title }"
                class="form-control"
                :value="landingPage.title"
                @input="
                  $emit('update:landingPage', {
                    ...landingPage,
                    title: $event.target.value,
                  })
                "
                @blur="checkTitleRequired"
              />
              <div
                class="invalid-feedback"
                v-if="saveLandingPageStateError.title"
              >
                ระบุชื่อหน้า
              </div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">ลิ้งค์</h5>
              <input
                type="text"
                placeholder="ใส่ลิ้งค์ที่ต้องการ"
                :class="{ 'is-invalid': saveLandingPageStateError.redirectUrl }"
                class="form-control"
                :value="landingPage.redirectUrl"
                @input="
                  $emit('update:landingPage', {
                    ...landingPage,
                    redirectUrl: $event.target.value,
                  })
                "
                @blur="checkURLRequired"
              />
              <div
                class="invalid-feedback"
                v-if="saveLandingPageStateError.redirectUrl"
              >
                {{saveLandingPageStateError.redirectUrl}}
              </div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">เริ่มเผยแพร่</h5>
              <DateTimePicker
                v-model="landingPage.startPublish"
                placeholder="กรุณาเลือกวันที่"
              />
            </FormGroup>
            <FormGroup>
              <h5 class="name">สิ้นสุดการเผยแพร่</h5>
              <DateTimePicker
                v-model="landingPage.endPublish"
                placeholder="กรุณาเลือกวันที่"
              />
            </FormGroup>
          </div>
          <div class="col-md-4"></div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
/* eslint-disable max-len */
import dateFormetter from '@/utils/dateFormatter';
import FormGroup from '@/components/FormGroup.vue';
import Section from '@/components/Section.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';

export default {
  mixins: [dateFormetter],
  props: {
    landingPage: {
      type: Object,
      default: () => {},
    },
    saveLandingPageStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormGroup,
    Section,
    DateTimePicker,
  },
  data() {
    return {
      saveLandingPage: {
        isSaving: false,
        isSaved: false,
        error: null,
      },
    };
  },
  created() {
    this.load();
  },
  computed: {},
  methods: {
    async load() {
      // load
    },
    checkTitleRequired(event) {
      if (!event.target.value) {
        this.$emit('update:saveLandingPageStateError', {
          ...this.saveLandingPageStateError,
          title: 'ระบุชื่อหน้า',
        });
      } else {
        this.$emit('update:saveLandingPageStateError', {
          ...this.saveLandingPageStateError,
          title: null,
        });
      }
    },
    checkURLRequired(event) {
      if (!event.target.value) {
        this.$emit('update:saveLandingPageStateError', {
          ...this.saveLandingPageStateError,
          redirectUrl: 'ระบุลิ้งค์',
        });
      } else if (!this.isValidURL(event.target.value)) {
        this.$emit('update:saveLandingPageStateError', {
          ...this.saveLandingPageStateError,
          redirectUrl: 'รูปแบบของ URL ไม่ถูกต้อง ตัวอย่างเช่น https://www.google.co.th',
        });
      } else {
        this.$emit('update:saveLandingPageStateError', {
          ...this.saveLandingPageStateError,
          redirectUrl: null,
        });
      }
    },
    isValidURL(str) {
      const httpregexp = /http|https/;
      const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (httpregexp.test(str)) {
        if (regexp.test(str)) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/variables.scss";
@import "./src/assets/scss/themes/components/form.scss";
@import "./src/assets/scss/themes/components/section-container.scss";
</style>
